import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import IwsUpload from '@comp/upload/IwsUpload';
import { queryUserTreeList } from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import pick from 'lodash.pick';
import moment from 'moment';
import { httpAction } from '@/api/manage';
import workfLow from '@comp/workFlow/workFlow.vue';
export default {
  name: 'SiteFileModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload: IwsUpload,
    workfLow: workfLow
  },
  data: function data() {
    return {
      title: '报备文件',
      tableName: 'om_site_file',
      form_fields: ['siteId', 'userId', 'category', 'title', 'remark', 'instrumentModel', 'description'],
      form_fields_time: ['fileDate'],
      validatorRules: {
        userId: {
          rules: [{
            required: true,
            message: '请输入运维人员!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请输入报备类型!'
          }]
        },
        fileDate: {
          rules: [{
            required: true,
            message: '请输入报备时间!'
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入标题!'
          }]
        }
      },
      siteName: '',
      loginUser: '',
      userTree: [],
      //人员信息
      addState: false,
      tabsKey: '1'
    };
  },
  props: ['pagePath'],
  watch: {
    currentSiteName: function currentSiteName(newVal, oldVal) {
      this.siteName = newVal;
    },
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    }
  },
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id, this.loadTreeList();
  },
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.addState = false;
      this.tabsKey = '1';

      if (!this.model.id) {
        this.model.fileDate = new Date().toLocaleDateString();
        this.model.userId = this.loginUser;
        this.model.siteId = this.siteId;
      } else {
        this.addState = true;
      }

      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    handleCancel: function handleCancel() {
      this.$emit('ok');
      this.close();
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this2.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};